import { render, staticRenderFns } from "./AssignDialog.vue?vue&type=template&id=2e6e79fa&scoped=true&"
import script from "./AssignDialog.vue?vue&type=script&lang=ts&"
export * from "./AssignDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AssignDialog.vue?vue&type=style&index=0&id=2e6e79fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6e79fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VBtn,VCard,VDialog,VRow,VSubheader})
